<template>
  <iframe :src="iframeUTM" 
  frameborder="0" 
  allowfullscreen="allowfullscreen" 
  webkitallowfullscreen="" 
  mozallowfullscreen="" 
  oallowfullscreen="" 
  msallowfullscreen="">
  </iframe>
</template>


<script>
export default {
  props: {
    iframe: String,
  },
  data: () => ({
    
  }),
  computed: {
    iframeUTM() {
      if( this.iframe.indexOf('?') > -1) {
        return `${this.iframe}&${this.$root.$cjer.utmString()}`;
      } else {
        return `${this.iframe}?${this.$root.$cjer.utmString()}`;
      }
    }
  }
}
</script>
